import Image from "next/image";

const CapitalEfficiency = ({ data }) => {
  const { sectionTitle, capitalParticipation } = data;

  return (
    <section className="pb-sp-100 sm:pb-sp-big">
      <div className="container mx-auto px-3">
        <h2 className="text-textxl text-baseBlack text-center mb-6 sm:text-lg font-medium">
          {sectionTitle}
        </h2>

        <div className="flex flex-wrap justify-center gap-6 sm:gap-4">
          {capitalParticipation.map((item) => (
            <div
              key={item.id}
              className="flex items-center justify-between bg-white border border-[#C4C4C4] rounded-xl w-[48%] sm:w-full overflow-hidden"
            >
              <div className="px-4 py-12 sm:py-4 w-3/5">
                <h3 className="text-3xl sm:text-lg font-semibold mb-xsp bg-gradient-to-r from-[#E3A003] to-[#E70404] bg-clip-text text-transparent">
                  {item.heading}
                </h3>

                <p className="text-lg sm:text-base text-baseBlack">
                  {item.subHeading}
                </p>
              </div>

              {/* Right Image */}
              <div className="w-2/5 h-full">
                <Image
                  src={item.image}
                  width={260}
                  height={160}
                  alt={item.heading}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CapitalEfficiency;
